"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const types_1 = require("@pbl/pbl-react-core/lib/models/survey/types");
const classnames_1 = require("classnames");
const _ = require("lodash");
const React = require("react");
const CardBody_1 = require("../card/CardBody");
const assets_1 = require("../config/assets");
const config_1 = require("../config/config");
const SurveyScreenStyle_1 = require("./jss/SurveyScreenStyle");
const SurveyImage_1 = require("./SurveyImage");
class SingleSelectQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.setRadioValue = (_event, value) => {
            this.setValuebyString(value);
        };
        this.setDropDownValue = (event) => {
            if (event.target.value) {
                this.setValuebyString(event.target.value);
            }
        };
        this.setValuebyString = (strVal) => {
            const { question, onChange } = this.props;
            const value = this.state.options.find((option) => option.id.toString() === strVal.toString()) || null;
            this.setState({ value });
            onChange(question, value);
        };
        this.renderDropDown = () => {
            const { classes, groupName } = this.props;
            const { value } = this.state;
            return ((0, jsx_runtime_1.jsxs)(core_1.FormControl, Object.assign({ className: classes.dropDownRoot }, { children: [(0, jsx_runtime_1.jsx)("label", Object.assign({ style: {
                            position: 'absolute',
                            overflow: 'hidden',
                            clip: 'rect(0 0 0 0)',
                            height: '1px; width: 1px',
                            margin: '-1px; padding: 0; border: 0'
                        }, htmlFor: `Answer-${groupName}` }, { children: `Answer-${groupName}` })), (0, jsx_runtime_1.jsxs)(core_1.Select, Object.assign({ name: 'answer-' + groupName, value: value && value.value ? value.id : '', displayEmpty: true, inputProps: { className: classes.selectLabel, id: 'Answer-' + groupName }, onChange: this.setDropDownValue }, { children: [(0, jsx_runtime_1.jsx)(core_1.MenuItem, Object.assign({ value: "" }, { children: (0, jsx_runtime_1.jsx)("em", { children: "--Select--" }) })), this.state.options.map((option, index) => ((0, jsx_runtime_1.jsx)(core_1.MenuItem, Object.assign({ value: option.id }, { children: _.unescape(option.value) }), index)))] }))] })));
        };
        this.renderRadioButton = () => {
            const { groupName } = this.props;
            const { value } = this.state;
            return ((0, jsx_runtime_1.jsx)(core_1.RadioGroup, Object.assign({ "aria-label": 'Answer-' + groupName, name: 'answer-' + groupName, value: value && value.value ? value.id : '', onChange: this.setRadioValue }, { children: this.state.options.map((option, index) => this.renderOptions(index, option)) })));
        };
        this.renderOptions = (index, option) => {
            const { classes, questionIndex, groupName, isQuizStyleAplied, imageSurveyLayout, quizPostSuccess, question, quizRetryResponse, isQuizRetry } = this.props;
            const { value } = this.state;
            const imageClass = imageSurveyLayout !== 'list' ? classes.optionImage : classes.optionImageLarge;
            let quizResponseObj;
            if (quizRetryResponse && (quizRetryResponse === null || quizRetryResponse === void 0 ? void 0 : quizRetryResponse.length) > 0) {
                quizResponseObj = quizRetryResponse.find(q => { var _a, _b; return ((_a = q === null || q === void 0 ? void 0 : q.question_id) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = question === null || question === void 0 ? void 0 : question.id) === null || _b === void 0 ? void 0 : _b.toString()); });
            }
            else {
                quizResponseObj = !!quizPostSuccess
                    ? quizPostSuccess.quiz_response.find(q => q.question_id.toString() === question.id.toString())
                    : undefined;
            }
            const isSelectedOptionCorrect = this.isQuizAnswerCorrect(quizResponseObj);
            const isOptionCorrect = !!quizResponseObj &&
                !!quizResponseObj.correct_answers &&
                quizResponseObj.correct_answers.includes(_.toNumber(option.id));
            const isSelected = value && value.value ? value.id === option.id : false;
            let showGreeenBorder = isSelectedOptionCorrect && isOptionCorrect;
            if (!isQuizRetry) {
                showGreeenBorder = isOptionCorrect;
            }
            const showRedBorder = !isQuizRetry && isSelected && !!quizResponseObj;
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: isQuizStyleAplied
                    ? {
                        border: '3px solid',
                        padding: '5px 10px 0px 15px',
                        marginBottom: '8px',
                        borderColor: showGreeenBorder
                            ? '#5cb860'
                            : showRedBorder
                                ? '#f55a4e'
                                : this.props.theme.palette.grey[500]
                    }
                    : {} }, { children: [!config_1.config.internalConfig.SHOW_TITLE_ABOVE_IMAGE && option.image_url && ((0, jsx_runtime_1.jsx)(SurveyImage_1.default, { imageUrl: option.image_url, imageTitle: option.value, imageClass: imageClass })), (0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { className: classes.radioContent, value: option.id, htmlFor: 'answer-' + option.value + questionIndex, control: (0, jsx_runtime_1.jsx)(core_1.Radio, { checked: value && value.value ? value.id === option.id : false, id: 'answer-' + option.value + questionIndex, name: 'answer-' + groupName, className: (0, classnames_1.default)(classes.radioButton, 'radioButton'), color: 'primary' }), label: _.unescape(option.value) }, option.id), config_1.config.internalConfig.SHOW_TITLE_ABOVE_IMAGE && option.image_url && ((0, jsx_runtime_1.jsx)(SurveyImage_1.default, { imageUrl: option.image_url, imageTitle: option.value, imageClass: imageClass }))] }), index));
        };
        this.isQuizAnswerCorrect = (quizResponseObj) => {
            if (!quizResponseObj)
                return undefined;
            const compareFunction = (a, b) => {
                if (a < b)
                    return -1;
                if (a > b)
                    return 1;
                return 0;
            };
            const sortAnswers = (answers) => answers ? [...answers].sort(compareFunction) : undefined;
            const sortSelectedAnswers = sortAnswers(quizResponseObj.selected_answers);
            const sortCorrectAnswers = sortAnswers(quizResponseObj.correct_answers);
            return sortSelectedAnswers && sortCorrectAnswers
                ? JSON.stringify(sortSelectedAnswers) === JSON.stringify(sortCorrectAnswers)
                : undefined;
        };
        this.state = {
            value: null,
            options: []
        };
    }
    componentDidMount() {
        const { answer, question: { options, answer_options } } = this.props;
        if (options) {
            this.setState({ options });
            if (answer && options && options.length > 0) {
                const surveyOption = options.find((option) => option.value === answer.value) || null;
                this.setState({ value: surveyOption });
            }
        }
        else if (answer_options) {
            const surveyOptions = _.sortBy(answer_options, 'display_order');
            this.setState({ options: surveyOptions });
            if (answer && surveyOptions && surveyOptions.length > 0) {
                const surveyOption = surveyOptions.find((option) => option.id.toString() === answer.selected_answers[0].toString()) || null;
                this.setState({ value: surveyOption });
            }
        }
    }
    render() {
        const { question, layout, theme, quizPostSuccess, quizRetryResponse } = this.props;
        let quizResponseObj;
        if (quizRetryResponse && (quizRetryResponse === null || quizRetryResponse === void 0 ? void 0 : quizRetryResponse.length) > 0) {
            quizResponseObj = quizRetryResponse.find(q => q.question_id.toString() === question.id.toString());
        }
        else {
            quizResponseObj = !!quizPostSuccess
                ? quizPostSuccess.quiz_response.find(q => q.question_id.toString() === question.id.toString())
                : undefined;
        }
        const isAnsweredCorrect = this.isQuizAnswerCorrect(quizResponseObj);
        const isSelectLayout = (layout === null || layout === void 0 ? void 0 : layout.toLowerCase()) === types_1.SurveyQuestionLayoutType.SELECT.toString().toLowerCase();
        const shouldUseDropdown = isSelectLayout || (!layout && this.state.options.length > 4);
        const renderComponent = shouldUseDropdown ? this.renderDropDown() : this.renderRadioButton();
        return ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ xs: 12, item: true, style: { paddingBottom: theme.spacing(2) } }, { children: (0, jsx_runtime_1.jsxs)(core_1.Card, Object.assign({ style: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(core_1.CardHeader, { title: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "subtitle1", component: 'span', style: {
                                color: theme.palette.text.primary,
                                paddingTop: theme.spacing(4),
                                paddingBottom: theme.spacing(4),
                                textAlign: 'start'
                            } }, { children: question.value })), style: {
                            backgroundColor: theme.palette.grey.A200
                        } }), (0, jsx_runtime_1.jsxs)(CardBody_1.default, { children: [!!quizResponseObj && ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ style: { marginBottom: theme.spacing(1) } }, { children: (0, jsx_runtime_1.jsx)("img", { src: isAnsweredCorrect
                                        ? assets_1.assets.internalAssets.correctIcon
                                        : assets_1.assets.internalAssets.incorrectIcon }) }))), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ xs: 12, item: true, style: { paddingBottom: theme.spacing(2) } }, { children: renderComponent }))] })] })) })));
    }
}
exports.default = (0, core_1.withTheme)((0, core_1.withStyles)(SurveyScreenStyle_1.default)(SingleSelectQuestion));
//# sourceMappingURL=SingleSelectQuestion.js.map